module.exports = __webpack_public_path__ + "static/img/pay-en-btn.84671a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer1/pay/pay-en-btn.png
// module id = YABr
// module chunks = 1